import RecordsPage from '../common/RecordsPage';
import type { FinanceCtx } from '../financeApi';

export default function IncomeRecords({ ctx }: { ctx: FinanceCtx }) {
  return <RecordsPage ctx={ctx} type="수입" />;
}
